<div class="title-container">
  <h2 mat-dialog-title>
    <span class="discussion-about">{{ 'APPLICATION.DISCUSSION_ABOUT' | translate }}</span>
    <span class="document-name" [attr.title]="data.docName">{{ data.docName }}</span>
  </h2>
  <button
    mat-icon-button
    type="button"
    class="close-button-wrapper"
    [attr.aria-label]="'COMMON.ACTION.CLOSE' | translate"
    (click)="closeDialog()">
    <mat-icon aria-hidden="true">close</mat-icon>
  </button>
</div>
@if (myself$ | async; as myself) {
  <mat-dialog-content
    class="mat-typography discussion-content"
    #dialogContent
    (pointerdown)="startContentDrag($event)"
    (pointermove)="moveContentDrag($event)"
    (pointerup)="stopContentDrag($event)"
    (pointercancel)="stopContentDrag($event)">
    <div
      class="comments-wrapper"
      [class.empty]="!(allComments$ | async)?.length && (loadingComments$ | async) === false">
      @if ((allComments$ | async)?.length) {
        @for (comment of allComments$ | async; track comment; let commentIndex = $index) {
          <div class="comment-wrapper">
            <div
              class="comment-content"
              matTooltip="{{ comment.author.name || comment.author.email }}"
              matTooltipClass="chatTooltip"
              matTooltipPosition="left"
              matTooltipShowDelay="450"
              [attr.data-cy]="'message-' + commentIndex"
              [class.author-comments]="comment.author.id === myself.id"
              [class.during-edition]="editingComment?.id === comment.id"
              [class.interlocutor-comments]="comment.author.id !== myself.id"
              [innerHTML]="comment.content | linebreaks"></div>
            <div class="created-at-wrapper">
              <p class="created-at-content" [class.dark]="comment.author.id === myself.id">
                {{ comment.createdAt | date: 'dd-MM-yyyy HH:mm' }}
              </p>
            </div>
            <!-- EDIT & DELETE unavailable for foreigners -->
            @if (myself.role.key !== ROLES_KEYS.Foreigner && comment.author.id === myself.id) {
              <div class="actions-wrapper">
                <button
                  type="button"
                  class="comment-action"
                  (click)="editComment(comment)"
                  [attr.data-cy]="'message-edit-' + commentIndex">
                  {{ 'COMMON.ACTION.EDIT' | translate }}
                </button>
                |
                @if (editingComment?.id === comment.id) {
                  <button
                    type="button"
                    class="comment-action"
                    (click)="cancelEdit()"
                    [attr.data-cy]="'message-cancel-edit-' + commentIndex">
                    {{ 'DISCUSSION_MODAL.CANCEL-EDITING' | translate }}
                  </button>
                }
                @if (editingComment?.id !== comment.id) {
                  <button
                    type="button"
                    class="comment-action"
                    (click)="removeComment(comment)"
                    [attr.data-cy]="'message-remove-' + commentIndex">
                    {{ 'COMMON.ACTION.REMOVE' | translate }}
                  </button>
                }
              </div>
            }
          </div>
        }
      } @else {
        <div class="no-messages-info">
          @if ((loadingComments$ | async) === false) {
            <h2>
              {{ 'CHAT.NO_MESSAGES_RELATED_THIS_DOCUMENT' | translate }}
            </h2>
          }
        </div>
      }
      @if (loadingComments$ | async) {
        <div class="loading-wrapper" role="status" aria-live="polite">
          <span class="sr-only">
            {{ 'COMMON.LAYOUT.LOADING' | translate }}
          </span>
          <mat-spinner [diameter]="40" [attr.aria-hidden]="true"></mat-spinner>
        </div>
      }
    </div>
  </mat-dialog-content>
}

<mat-dialog-actions>
  <div class="chat-message-input-wrapper standard-form-field">
    <mat-form-field class="chat-message-content-input" appearance="outline" subscriptSizing="dynamic">
      <textarea
        [appAutoFocus]="deviceInfo.deviceTypeDetected === 'DESKTOP'"
        matInput
        #commentInput
        id="chat-message-input-in-modal"
        #autosize="cdkTextareaAutosize"
        cdkTextareaAutosize
        cdkAutosizeMinRows="1"
        [cdkAutosizeMaxRows]="commentInputMaxRows"
        autocomplete="off"
        autocapitalize="off"
        [(ngModel)]="newCommentContent"
        (keydown.enter)="submitComment($event)"
        placeholder="{{ 'CHAT.ENTER_YOUR_MESSAGE' | translate }}"
        maxlength="1500"
        minlength="1"
        [attr.aria-describedby]="'discussion-comment-error'"
        required>
      </textarea>
      @if (newCommentContent && !commentContentValid()) {
        <div id="discussion-comment-error" class="mat-error">
          {{ 'CHAT.FORBIDDEN_CHARACTERS_USED' | translate }}
        </div>
      }
    </mat-form-field>
    @if (editingComment?.id) {
      <button
        class="cancel-edit-button"
        mat-icon-button
        [attr.aria-label]="'DISCUSSION_MODAL.CANCEL-EDITING' | translate"
        (click)="cancelEdit()">
        <mat-icon class="cancel-edit-chatMessage-icon">close</mat-icon>
      </button>
    }
    <button
      class="send-message-button"
      [disabled]="!newCommentContent || !commentContentValid()"
      mat-icon-button
      color="primary"
      [attr.aria-label]="'CHAT.SEND_MESSAGE' | translate"
      (click)="submitComment($event)">
      <mat-icon>send</mat-icon>
    </button>
  </div>
</mat-dialog-actions>
